import styled from 'styled-components';
import { colors } from '../../css';

export const StrengthIndicatorWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  padding-top: 15px;
  position: relative;
  background: linear-gradient(
      90deg,
      ${colors.colorGrey04} calc(33.3333% - (16px / 3)),
      transparent calc(33.3333% - (16px / 3))
    )
    no-repeat;
  background-size: 100% 5px;

  &:before,
  &:after {
    content: '';
    width: calc(33.3333% - (16px / 3));
    height: 5px;
    display: block;
    position: absolute;
    top: 0;
    background: ${colors.colorGrey04};
  }

  &:before {
    right: 50%;
    transform: translateX(50%);
  }

  &:after {
    right: 0;
  }

  .label,
  .strength {
    width: 50%;
    float: left;
  }
  .label {
    text-align: left;
  }
  .strength {
    text-align: right;
  }

  &.Weak {
    background: linear-gradient(90deg, #e80006 calc(33.3333% - (16px / 3)), transparent calc(33.3333% - (16px / 3)))
      no-repeat;
    background-size: 100% 5px;
    .strength {
      color: #e80006;
    }
  }

  &.Fair {
    background: linear-gradient(
        90deg,
        ${colors.colorGrey03} calc(33.3333% - (16px / 3)),
        transparent calc(33.3333% - (16px / 3))
      )
      no-repeat;
    background-size: 100% 5px;
    &:before {
      background: ${colors.colorGrey03};
    }
  }
  &.Strong {
    background: linear-gradient(90deg, #00b361 calc(33.3333% - (16px / 3)), transparent calc(33.3333% - (16px / 3)))
      no-repeat;
    background-size: 100% 5px;
    &:before,
    &:after {
      background: #00b361;
    }
  }
`;
